import React from 'react';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';

function AboutPage() {

  return (
    <div className="news-portal">
      <SiteHeader />

      {/* Main Content */}
      <main className="news-main">
        <div className="container">
          <div className="legal-page">
            <h1 className="legal-page-title">About Us</h1>

            <blockquote className="legal-blockquote">
              "The goal isn't to live forever, but to create a body and mind that allow you to live fully until the very end."
            </blockquote>

            <p>
              At Daily Health News, we aren't just interested in adding years to your life; we're dedicated to adding life to your years. We explore the frontier of human lifespan. From the latest breakthroughs in senolytic research to the foundational habits of the world's "Blue Zones," we translate complex geroscience into actionable insights for your daily life.
            </p>

            <h2>Our Core Pillars</h2>
            <ul>
              <li><strong>Biological Optimization:</strong> Understanding the mechanics of aging—from telomere health to mitochondrial function.</li>
              <li><strong>Proactive Wellness:</strong> Moving beyond "sick care" into a world of preventative health and personalized nutrition.</li>
              <li><strong>Lifestyle Engineering:</strong> Practical guides on sleep hygiene, heat/cold exposure, and movement patterns that preserve vitality.</li>
              <li><strong>The Longevity Tech Stack:</strong> Evidence-based reviews of supplements, wearables, and diagnostic tools.</li>
            </ul>

            <h2>Our Mission</h2>
            <p>
              Aging was once thought to be an inevitable slide toward decline. Today, science suggests it's a malleable process. Our mission is to empower you with the data and tools necessary to slow the clock, sharpen your mind, and maintain peak physical performance at any age.
            </p>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}

export default AboutPage;
